"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var colors_1 = require("../ThemeProvider/colors");
__exportStar(require("@mui/material/Tooltip"), exports);
var Container = (0, material_1.styled)('div')({
    borderTop: "1px solid ".concat(colors_1.tannerGray['600']),
    margin: '8px -12px -8px -12px',
    padding: '4px 12px 5px 12px;',
});
var Callout = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(Container, null, children);
};
var Tooltip = Object.assign(Tooltip_1.default, { Callout: Callout });
exports.default = Tooltip;
//# sourceMappingURL=index.js.map